module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./~/rss-parser-browser/~/entities/maps/xml.json
// module id = 367
// module chunks = 1